<!-- 系统概况 -->
<template>
  <div class="app-container">
    <div v-loading="overviewLoading" class="app-content" element-loading-text="加载中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.7)">
      <!-- 发电信息卡片 -->
      <el-card class="energy-card">
        <template #header>
          {{ $t('text.fdxx') }}
        </template>
        <template #default>
          <div>
            <p><img src="../../assets/icon/gonglv.png" alt=""></p>
            <p>{{ $t('text.dqgl') }}</p>
            <p>{{ overview.power | objValue('cvalue',0) }}{{ overview.power | objValue('cvalue',1) }}</p>
          </div>
          <div>
            <p><img src="../../assets/icon/zhuangji.png" alt=""></p>
            <p>{{ $t('text.zjrl') }}</p>
            <p>{{ overview.capacity | objValue('cvalue', 0) }}{{ overview.capacity | objValue('cvalue', 1) }}</p>
          </div>
          <div>
            <p><img src="../../assets/icon/ri.png" alt=""></p>
            <p>{{ $t('text.drdl') }}</p>
            <p>{{ overview.ymdEnergy | objValue(['dayEnergy','f', 'cvalue'],0) }}{{ overview.ymdEnergy | objValue(['dayEnergy', 'f','cvalue'],1) }}</p>
          </div>
          <div>
            <p><img src="../../assets/icon/yue.png" alt=""></p>
            <p>{{ $t('text.dydl') }}</p>
            <p>{{ overview.ymdEnergy | objValue(['monthEnergy','f', 'cvalue'],0) }}{{ overview.ymdEnergy | objValue(['monthEnergy','f', 'cvalue'],1) }}</p>
          </div>
          <div>
            <p><img src="../../assets/icon/nian.png" alt=""></p>
            <p>{{ $t('text.dndl') }}</p>
            <p>{{ overview.ymdEnergy | objValue(['yearEnergy','f', 'cvalue'],0) }}{{ overview.ymdEnergy | objValue(['yearEnergy','f', 'cvalue'],1) }}</p>
          </div>
          <div>
            <p><img src="../../assets/icon/zong.png" alt=""></p>
            <p>{{ $t('text.zdl') }}</p>
            <p>{{ overview.ymdEnergy | objValue(['totalEnergy','f', 'cvalue'],0) }}{{ overview.ymdEnergy | objValue(['totalEnergy','f', 'cvalue'],1) }}</p>
          </div>
        </template>
      </el-card>

      <!-- 逆变器信息卡片 -->
      <el-card class="inverter-card">
        <template #header>
          {{ $t('text.nbq') }}
        </template>
        <template #default>
          <div v-if="overview.inverterCnt.totals > 0" id="inverter_chart" />
          <div v-else>暂未接入逆变器设备</div>
        </template>
      </el-card>

      <!-- 电站信息卡片 -->
      <el-card class="station-card">
        <template #header>
          {{ $t('text.dz') }}
        </template>
        <template #default>
          <div id="station_chart" />
          <div class="status-detail">
            <el-statistic
              title="在线"
              suffix="个"
              :value="overview.stationsCnt.onlines"
              :precision="0"
            />
            <el-statistic
              title="部分离线"
              suffix="个"
              :value="overview.stationsCnt.partOnlines"
              :precision="0"
            />
            <el-statistic
              title="离线"
              suffix="个"
              :value="overview.stationsCnt.offlines"
              :precision="0"
            />
            <el-statistic
              title="告警"
              suffix="个"
              :value="overview.stationsCnt.alarms"
              :precision="0"
            />
          </div>
        </template>
      </el-card>

      <!-- 监控信息卡片 -->
      <el-card class="gateway-card">
        <template #header>
          {{ $t('text.gateway') }}
        </template>
        <template #default>
          <div id="gateway_chart_left" />
          <div id="gateway_chart_right" />
        </template>
      </el-card>

      <!-- 设备信息卡片 -->
      <el-card class="device-card">
        <template #header>
          {{ $t('text.sb') }}
        </template>
        <template #default>
          <div class="top">
            <el-statistic
              title="逆变器"
              suffix="个"
              :value="overview.devicesCnt.inverterTotals"
              :precision="0"
            />
            <el-statistic
              title="电表"
              suffix="个"
              :value="overview.devicesCnt.meterTotals"
              :precision="0"
            />
            <el-statistic
              title="气象仪"
              suffix="个"
              :value="overview.devicesCnt.atmospheriumTotals"
              :precision="0"
            />
            <el-statistic
              title="其它设备"
              suffix="个"
              :value="overview.devicesCnt.otherTotals"
              :precision="0"
            />
            <el-statistic
              title="设备总数"
              suffix="个"
              :value="overview.devicesCnt.totals"
              :precision="0"
            />
          </div>
          <div class="bottom">
            <div>
              <p>
                <label>电表在线: {{ overview.devicesCnt.meterOnlines }}台</label>
              </p>
              <el-progress :percentage="meterOnlineRate" :show-text="false" color="#1BB78A" define-back-color="gray" />
            </div>
            <div>
              <p>
                <label>逆变器在线: {{ overview.devicesCnt.inverterOnlines }}台</label>
              </p>
              <el-progress :percentage="inverterOnlineRate" :show-text="false" color="#4ca0de" define-back-color="gray" />
            </div>
            <div>
              <p>气象仪在线: {{ overview.devicesCnt.atmospheriumOnlines }}台</p>
              <el-progress :percentage="weatherOnlineRate" :show-text="false" color="#ee7650" define-back-color="gray" />
            </div>
            <div>
              <p>其它设备占比: {{ otherRatio }} %</p>
              <el-progress :percentage="otherRatio" :show-text="false" color="#f9d237" define-back-color="gray" />
            </div>
          </div>
        </template>
      </el-card>
    </div>
  </div>
</template>

<script>
import { GetManagerOverviewData } from '@apis/Statistics'
import { getEchart } from '../../utils/echarts'
import colorConfig from '../../utils/color'
export default {
  data () {
    return {
      colors: colorConfig,
      // 概览数据加载中
      overviewLoading: true,
      // 概览数据
      overview: {
        inverterCnt: {},
        stationsCnt: {},
        gatewaysCnt: {
          totals: 0,
          installeds: 0,
          onlines: 0,
          offlines: 0,
          alarms: 0
        },
        devicesCnt: {
          inverterTotals: 0,
          inverterOnlines: 0,
          meterTotals: 0,
          meterOnlines: 0,
          atmospheriumTotals: 0,
          atmospheriumOnlines: 0,
          otherTotals: 0,
          totals: 189
        }
      },
      // 逆变器信息卡片配置
      inverterChartOptions: {
        color: [colorConfig.online, colorConfig.alarm, colorConfig.offline],
        tooltip: {
          show: false
        },
        legend: {
          right: '20%',
          bottom: "35%",
          orient: "vertical",
          itemGap: 30,
          data: [
            {
              name: '在线',
              icon: 'circle',
              textStyle: {
                color: '#fff'
              }
            },
            {
              name: '告警',
              icon: 'circle',
              textStyle: {
                color: '#fff'
              }
            },
            {
              name: '离线',
              icon: 'circle',
              textStyle: {
                color: '#fff'
              }
            }
          ]
        },
        series: [
          {
            name: 'InverterStatus',
            type: 'pie',
            radius: ['55%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            hoverOffset: 0,
            data: [
              { value: 0, name: '在线' },
              { value: 0, name: '告警' },
              { value: 0, name: '离线' },
            ]
          },
          {
            name: 'InverterTotal',
            type: 'gauge',
            axisLabel: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            pointer: {
              show: false
            },
            title: {
              offsetCenter: [0, 10],
              color: '#ffffff'
            },
            detail: {
              offsetCenter: [0, -20],
              color: '#ffffff'
            },
            data: [
              {
                value: 0,
                name: '逆变器总数',
              }
            ]
          }
        ]
      },
      // 电站信息卡片配置
      stationChartOptions: {
        color: [colorConfig.online, colorConfig.partOnline, colorConfig.alarm, colorConfig.offline],
        tooltip: {
          show: false
        },
        legend: {
          right: '20%',
          bottom: "30%",
          orient: "vertical",
          itemGap: 10,
          data: [
            {
              name: '在线',
              icon: 'circle',
              textStyle: {
                color: '#fff'
              }
            },
            {
              name: '部分离线',
              icon: 'circle',
              textStyle: {
                color: '#fff'
              }
            },
            {
              name: '告警',
              icon: 'circle',
              textStyle: {
                color: '#fff'
              }
            },
            {
              name: '离线',
              icon: 'circle',
              textStyle: {
                color: '#fff'
              }
            }
          ]
        },
        series: [
          {
            name: '电站状态状态',
            type: 'pie',
            radius: ['60%', '80%'],
            center: ['30%', '50%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            hoverOffset: 0,
            data: [
              { value: 0, name: '在线' },
              { value: 0, name: '部分离线' },
              { value: 0, name: '告警' },
              { value: 0, name: '离线' },
            ]
          },
          {
            name: '电站总数',
            type: 'gauge',
            center: ['30%', '50%'],
            axisLabel: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            pointer: {
              show: false
            },
            title: {
              offsetCenter: [0, 15],
              color: '#ffffff',
              fontSize: 12
            },
            detail: {
              offsetCenter: [0, -10],
              color: '#ffffff',
              fontSize: 16
            },
            data: [
              {
                value: 0,
                name: '采集器已使用',
              }
            ]
          }
        ]
      },
      // 采集器图表配置
      gatewayChartOptions: {
        // 左侧的总数和已安装数
        left: {
          color: [colorConfig.isRunning, colorConfig.unRunning],
          tooltip: {
            show: false
          },
          legend: {
            right: '15%',
            bottom: "40%",
            orient: "vertical",
            itemGap: 10,
            data: [
              {
                name: '已使用 0',
                icon: 'circle',
                textStyle: {
                  color: '#fff'
                }
              },
              {
                name: '未使用 0',
                icon: 'circle',
                textStyle: {
                  color: '#fff'
                }
              }
            ]
          },
          series: [
            {
              name: '采集器安装情况',
              type: 'pie',
              radius: ['60%', '80%'],
              center: ['30%', '50%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: 'center'
              },
              labelLine: {
                show: false
              },
              hoverOffset: 0,
              data: [
                { value: 0, name: '已使用 0' },
                { value: 0, name: '未使用 0' },
              ]
            },
            {
              name: '采集器总数情况',
              type: 'gauge',
              center: ['30%', '50%'],
              axisLabel: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              splitLine: {
                show: false
              },
              pointer: {
                show: false
              },
              title: {
                offsetCenter: [0, 15],
                color: '#ffffff',
                fontSize: 12
              },
              detail: {
                offsetCenter: [0, -10],
                color: '#ffffff',
                fontSize: 16
              },
              data: [
                {
                  value: 0,
                  name: '采集器总数',
                }
              ]
            }
          ]
        },
        // 右侧的在线数和离线数
        right: {
          color: [colorConfig.online, colorConfig.partOnline, colorConfig.alarm, colorConfig.offline],
          tooltip: {
            show: false
          },
          legend: {
            right: '15%',
            bottom: "30%",
            orient: "vertical",
            itemGap: 10,
            data: [
              {
                name: '在线 0',
                icon: 'circle',
                textStyle: {
                  color: '#fff'
                }
              }, {
                name: '部分离线 0',
                icon: 'circle',
                textStyle: {
                  color: '#fff'
                }
              },
              {
                name: '告警 0',
                icon: 'circle',
                textStyle: {
                  color: '#fff'
                }
              },
              {
                name: '离线 0',
                icon: 'circle',
                textStyle: {
                  color: '#fff'
                }
              }
            ]
          },
          series: [
            {
              name: '采集器状态',
              type: 'pie',
              radius: ['60%', '80%'],
              center: ['30%', '50%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: 'center'
              },
              labelLine: {
                show: false
              },
              hoverOffset: 0,
              data: [
                { value: 0, name: '在线  0' },
                { value: 0, name: '部分离线  0' },
                { value: 0, name: '告警  0' },
                { value: 0, name: '离线  0' },
              ]
            },
            {
              name: '采集器使用总数',
              type: 'gauge',
              center: ['30%', '50%'],
              axisLabel: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              splitLine: {
                show: false
              },
              pointer: {
                show: false
              },
              title: {
                offsetCenter: [0, 15],
                color: '#ffffff',
                fontSize: 12
              },
              detail: {
                offsetCenter: [0, -10],
                color: '#ffffff',
                fontSize: 16
              },
              data: [
                {
                  value: 0,
                  name: '采集器已使用',
                }
              ]
            }
          ]
        }
      }
    }
  },
  computed: {
    // 计算电表在线率
    meterOnlineRate () {
      const { meterOnlines, meterTotals } = this.overview.devicesCnt
      const result = meterTotals === 0 ? 0 : meterOnlines / meterTotals * 100
      return Number(result.toFixed(2))
    },
    // 计算气象仪在线率
    weatherOnlineRate () {
      const { atmospheriumOnlines, atmospheriumTotals } = this.overview.devicesCnt
      const result = atmospheriumTotals === 0 ? 0 : atmospheriumOnlines / atmospheriumTotals * 100
      return Number(result.toFixed(2))
    },
    // 计算逆变器在线率
    inverterOnlineRate () {
      const { inverterOnlines, inverterTotals } = this.overview.devicesCnt
      const result = inverterTotals === 0 ? 0 : inverterOnlines / inverterTotals * 100
      return Number(result.toFixed(2))
    },
    // 计算其它设备占比
    otherRatio () {
      const { otherTotals, totals } = this.overview.devicesCnt
      const result = totals === 0 ? 0 : otherTotals / totals * 100
      return Number(result.toFixed(2))
    },
  },
  created () {
    if (this.$store.getters.id === process.env.VUE_APP_JinXiangHuaSheng_Userid) {
      // 金象华升账号登陆时，跳转到电站列表页
      this.$router.push({ path: '/list' })
    }
  },
  mounted () {
    if (this.$store.getters.id !== process.env.VUE_APP_JinXiangHuaSheng_Userid) {
      this.getOverviewData()
    }
  },
  methods: {

    /** 设置颜色 */
    setColors () {
    },

    /** 获取概览数据 */
    getOverviewData () {
      this.overviewLoading = true
      GetManagerOverviewData().then(res => {
        this.overview = res.data
      }).then(() => {
        const { inverterCnt } = this.overview
        if (inverterCnt.totals > 0) {
          this.inverterChartOptions.legend.data[0].name = '在线 ' + ' ' + ' ' + inverterCnt.onlines
          this.inverterChartOptions.series[0].data[0].name = '在线 ' + ' ' + ' ' + inverterCnt.onlines
          this.inverterChartOptions.series[0].data[0].value = inverterCnt.onlines

          this.inverterChartOptions.legend.data[1].name = '告警 ' + ' ' + ' ' + inverterCnt.alarms
          this.inverterChartOptions.series[0].data[1].name = '告警 ' + ' ' + ' ' + inverterCnt.alarms
          this.inverterChartOptions.series[0].data[1].value = inverterCnt.alarms

          this.inverterChartOptions.legend.data[2].name = '离线 ' + ' ' + ' ' + inverterCnt.offlines
          this.inverterChartOptions.series[0].data[2].name = '离线 ' + ' ' + ' ' + inverterCnt.offlines
          this.inverterChartOptions.series[0].data[2].value = inverterCnt.offlines

          this.inverterChartOptions.series[1].data[0].value = inverterCnt.totals
          getEchart(this.$echarts, 'inverter_chart', this.inverterChartOptions)
        }
      }).then(() => {
        const { stationsCnt } = this.overview

        this.stationChartOptions.series[0].data[0].value = stationsCnt.onlines
        this.stationChartOptions.series[0].data[1].value = stationsCnt.partOnlines
        this.stationChartOptions.series[0].data[2].value = stationsCnt.alarms
        this.stationChartOptions.series[0].data[3].value = stationsCnt.offlines

        this.stationChartOptions.series[1].data[0].value = stationsCnt.totals
        this.stationChartOptions.series[1].data[0].name = `已接入电站总数`
        getEchart(this.$echarts, 'station_chart', this.stationChartOptions)
      }).then(() => {
        const { gatewaysCnt } = this.overview
        const unInstalleds = gatewaysCnt.totals - gatewaysCnt.installeds
        this.gatewayChartOptions.left.legend.data[0].name = `已使用 ${gatewaysCnt.installeds}`
        this.gatewayChartOptions.left.legend.data[1].name = `未使用 ${unInstalleds}`

        this.gatewayChartOptions.left.series[0].data[0].name = `已使用 ${gatewaysCnt.installeds}`
        this.gatewayChartOptions.left.series[0].data[1].name = `未使用 ${unInstalleds}`
        this.gatewayChartOptions.left.series[0].data[0].value = gatewaysCnt.installeds
        this.gatewayChartOptions.left.series[0].data[1].value = unInstalleds
        this.gatewayChartOptions.left.series[1].data[0].value = gatewaysCnt.totals
        getEchart(this.$echarts, 'gateway_chart_left', this.gatewayChartOptions.left)

        this.gatewayChartOptions.right.legend.data[0].name = `在线 ${gatewaysCnt.onlines}`
        this.gatewayChartOptions.right.legend.data[1].name = `部分离线 ${gatewaysCnt.partOnlines}`
        this.gatewayChartOptions.right.legend.data[2].name = `告警 ${gatewaysCnt.alarms}`
        this.gatewayChartOptions.right.legend.data[3].name = `离线 ${gatewaysCnt.offlines}`

        this.gatewayChartOptions.right.series[0].data[0].name = `在线 ${gatewaysCnt.onlines}`
        this.gatewayChartOptions.right.series[0].data[1].name = `部分离线 ${gatewaysCnt.partOnlines}`
        this.gatewayChartOptions.right.series[0].data[2].name = `告警 ${gatewaysCnt.alarms}`
        this.gatewayChartOptions.right.series[0].data[3].name = `离线 ${gatewaysCnt.offlines}`
        this.gatewayChartOptions.right.series[0].data[0].value = gatewaysCnt.onlines
        this.gatewayChartOptions.right.series[0].data[1].value = gatewaysCnt.partOnlines
        this.gatewayChartOptions.right.series[0].data[2].value = gatewaysCnt.alarms
        this.gatewayChartOptions.right.series[0].data[3].value = gatewaysCnt.offlines

        this.gatewayChartOptions.right.series[1].data[0].value = gatewaysCnt.installeds
        getEchart(this.$echarts, 'gateway_chart_right', this.gatewayChartOptions.right)
      }).then(() => {
        this.overviewLoading = false
      }).catch(() => {
        this.overviewLoading = false
      })
    },
  }
}
</script>
<style scoped>
.app-content {
  height: calc(100vh - 100px - 30px);
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(30, 1fr);
  grid-gap: 10px;
}

/*** 发电信息卡片 */
.app-content .energy-card{
  grid-column: 1 / 2;
  grid-row: 1 / span 16;
}

/*** 逆变器信息卡片 */
.app-content .inverter-card{
  grid-column: 1 / 2;
  grid-row: 17 / span 14;
}

/*** 电站信息卡片 */
.app-content .station-card{
  grid-column: 2 / 3;
  grid-row: 1 / span 10;
}

/*** 监控信息卡片 */
.app-content .gateway-card{
  grid-column: 2 / 3;
  grid-row: 11 / span 10;
}

/*** 设备信息卡片 */
.app-content .device-card{
  grid-column: 2 / 3;
  grid-row: 21 / span 10;
}

.el-card {
  border: none;
  display: flex;
  flex-direction: column;
  background-color: #1d3565;
}
.el-card>>>.el-card__header {
  font-size: 18px;
  font-weight: bold;
  color: #5aa2c9;
  position: relative;
  padding:0 0 0 30px;
  border: none;
  height: 50px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.el-card>>>.el-card__header:before {
  content: '';
  width: 5px;
  height: 20px;
  background-color: #1fd09d;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 12px;
  margin: auto 0;
}
.el-card>>>.el-card__body {
  color: #fff;
  border: none;
  height: calc(100% - 50px);
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px 10px;
}

.energy-card>>>.el-card__body {
   display:grid;
   padding: 10px 20px;
   grid-template-rows: repeat(2, 1fr);
   grid-template-columns: repeat(3, 1fr);
   grid-gap: 20px;
}
.energy-card>>>.el-card__body>div {
  text-align: center;
}
.energy-card>>>.el-card__body img{
  height:100px;
  width: 100px;
}

.inverter-card>>>.el-card__body {
  display: flex;
  align-items: center;
  justify-content: center;
}

.station-card>>>.el-card__body {
  display: grid;
  grid-template-columns: 0.6fr 0.4fr;
}
.station-card>>>.el-card__body>.status-detail {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-gap: 20px;
}
.station-card>>>.el-card__body>.status-detail>.el-statistic {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: center;
}
.station-card>>>.el-card__body>.status-detail>.el-statistic .number{
  font-weight: bold;
  color: #fff;
  margin-bottom: 2px;
}
.station-card>>>.el-card__body>.status-detail>.el-statistic .suffix{
  color: #fff;
}
.station-card>>>.el-card__body>.status-detail>.el-statistic> .head{
  color: #5aa2c9;
}

.device-card>>>.el-card__body {
  height: 100%;
  width: 100%;
  padding: 0 20px 10px;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: 0.4fr 0.6fr;
}
.device-card>>>.el-card__body>.top{
  height: 100%;
  width: 100%;
  padding: 0;
  box-sizing: border-box;
  display:grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 10px;
}
.device-card>>>.el-card__body>.top>.el-statistic{
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: center;
}
.device-card>>>.el-card__body>.top>.el-statistic .number{
  font-weight: bold;
  color: #fff;
  margin-bottom: 2px;
}
.device-card>>>.el-card__body>.top>.el-statistic .suffix{
  color: #fff;
}
.device-card>>>.el-card__body>.top>.el-statistic> .head{
  color: #5aa2c9;
}
.device-card>>>.el-card__body>.bottom{
  height: 100%;
  width: 100%;
  padding: 0;
  box-sizing: border-box;
  display:grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 50px;
  align-items: center;
}

.gateway-card>>>.el-card__body {
  display: grid;
  grid-template-columns: repeat(2,1fr);
  grid-gap: 20px;
}

#inverter_chart,
#station_chart{
  height: 100%;
  width: 100%;
}

#gateway_chart_left,
#gateway_chart_right{
  height: 100%;
  width: 100%;
}
</style>
